import type { CalendarModuleModalStore } from './schema/CalendarModuleModalStore';
import { createStore } from 'satcheljs';

/**
 * This is the store for the modal states for the calendar module. When a modal is instantiated on the calendar store, if it only needs a
 * small amount of initialization state (such as the id of the selected item), it can be added here rather than needing a separate store.
 *
 * The modal view states in this store are null if the modal is hidden, and when state becomes non-null the modals can be rendered with the
 * data
 */
let calendarModuleModalStoreData: CalendarModuleModalStore = {
    deleteModalViewState: null,
    meetingDndModalViewState: null,
};

let calendarModuleModalStore = createStore<CalendarModuleModalStore>(
    'calendarModuleModalStoreData',
    calendarModuleModalStoreData
)();
export default calendarModuleModalStore;
